var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5713",
    "data-name": "Group 5713",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.071,
    height: 60.071,
    viewBox: "0 0 60.071 60.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 60.071,
    height: 60.071,
    fill: "#eff711"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5713-2",
    "data-name": "Group 5713",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M30.035,0A30.035,30.035,0,1,0,60.072,30.036,30.033,30.033,0,0,0,30.035,0M32.3,55.431V53.412a2.267,2.267,0,1,0-4.534,0v2.019a25.537,25.537,0,0,1-23.134-23.2H6.588a2.267,2.267,0,0,0,0-4.534H4.645A25.54,25.54,0,0,1,27.769,4.64V6.517a2.267,2.267,0,1,0,4.534,0V4.64A25.539,25.539,0,0,1,55.426,27.7H53.483a2.267,2.267,0,1,0,0,4.534h1.953A25.537,25.537,0,0,1,32.3,55.431",
    fill: "#e9b72f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M57.03,28.28,43.6,42.349c-.025,0-.05,0-.076,0a2.563,2.563,0,0,0-.491.048L31.8,33.9a1.7,1.7,0,0,0-2.045,2.719l11.234,8.488a2.549,2.549,0,0,0,5.089-.213c0-.068,0-.133-.01-.2l13.425-14.07A1.7,1.7,0,1,0,57.03,28.28",
    transform: "translate(-13.491 -12.877)",
    fill: "#e9b72f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingPayment);
export default __webpack_public_path__ + "static/media/pending-payment.d4608e9f5fca6ee5a30e6a423fe3d4ac.svg";
export { ForwardRef as ReactComponent };